// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"235":"aa07da5ec67f87ae","699":"71604269a1c1c373"}[chunkId] + ".js";
};